import { SlideDeckType } from '../types'

export function checkIsFreeType(type: SlideDeckType): boolean {
  return type === SlideDeckType.demo || type === SlideDeckType.tutorial
}
